import { Link } from "react-router-dom";

import i18next from "i18next";
import MoneeLogo from "../../Assets/Imgs/logo_monee.png";
import ShopeePayLogo from "../../Assets/Imgs/logo_shopeepay.png";

import "./style.less";

const NavbarLeft = () => {
  const currentLanguage = i18next.language;

  const handleOnClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <div className="navbar-left__content">
      <Link to={`/${currentLanguage}`} onClick={handleOnClick}>
        <img className="logo" src={MoneeLogo} alt="SeaMoney_Logo" />
      </Link>
      <Link to={`/${currentLanguage}`} onClick={handleOnClick}>
        <img className="logo" src={ShopeePayLogo} alt="ShopeePay_Logo" />
      </Link>
    </div>
  );
};

export default NavbarLeft;
